import { gql } from '@apollo/client/core';

export const RECORD_ORDER_FISCAL_COMMAND_LOGS = gql`
  mutation RecordOrderFiscalCommandLogs($input: RecordOrderFiscalCommandLogsInput!) {
    recordOrderFiscalCommandLogs(input: $input)
  }
`;
